import { createSlice } from '@reduxjs/toolkit';
import { AuthState } from './types';
import { setUserInfo, setToken, logout } from './actions';
// import { refreshUserInfoThunk } from './thunk';
import { Api } from '../../../core';

const initialAuthState: AuthState = {
  isAuth: false,
};

function __setUserInfo(state: any, userInfo: any) {
  localStorage.setItem('userInfo', JSON.stringify(userInfo));
  state.userInfo = userInfo;
}

export const authSlice = createSlice({
  name: 'auth',
  initialState: initialAuthState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setUserInfo, (state, action) => {
      const userInfo = action.payload;
      __setUserInfo(state, userInfo);
    });

    builder.addCase(setToken, (state, action) => {
      const token = action.payload;
      localStorage.setItem('token', token);
      state.token = token;
      Api.setBearerToken(token);
    });

    builder.addCase(logout, (state) => {
      localStorage.removeItem('token');
      localStorage.removeItem('userInfo');
      state.token = undefined;
      state.userInfo = undefined;
    });

    // builder.addCase(refreshUserInfoThunk.fulfilled, (state, action) => {
    //   __setUserInfo(state, action.payload);
    // });
  },
});

export default authSlice.reducer;
